import { drawingBackground, renderDrawing, renderDrawingStroke, type DrawingEditor } from '../shared/art/drawing';
import type { Stroke } from '../shared/art/types';

/** Cache completed ink; redraw only the live stroke over a clean base, including translucent brushes. */
export class DrawingEditorRenderer {
  private base: HTMLCanvasElement;
  private completed: { stroke: Stroke; points: number }[] = [];
  private editor?: DrawingEditor;
  private background?: string;
  constructor(createCanvas: (w: number, h: number) => HTMLCanvasElement, private size: number) { this.base = createCanvas(size, size); }
  render(ctx: CanvasRenderingContext2D, editor: DrawingEditor) {
    const drawing = editor.document, background = drawingBackground(drawing);
    const completedCount = drawing.strokes.length - editor.activeStrokeCount;
    const base = this.base.getContext('2d')!;
    if (this.editor !== editor || this.background !== background || this.completed.length > completedCount
      || this.completed.some((entry, i) => entry.stroke !== drawing.strokes[i] || entry.points !== entry.stroke.points.length)) {
      renderDrawing(base, { schemaVersion: 1, strokes: [], background }, this.size);
      this.completed = []; this.editor = editor; this.background = background;
    }
    for (let i = this.completed.length; i < completedCount; i++) {
      const stroke = drawing.strokes[i];
      renderDrawingStroke(base, stroke, this.size, background);
      this.completed.push({ stroke, points: stroke.points.length });
    }
    ctx.drawImage(this.base, 0, 0);
    for (let i = completedCount; i < drawing.strokes.length; i++) renderDrawingStroke(ctx, drawing.strokes[i], this.size, background);
  }
}
